import React, { useEffect } from 'react';
import './oficiniavirtualcontratista.css';

const OficinaVirtualContratista = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='title'>Contratistas</h1>
          <hr className='hr-gob'/>
        </div>

        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/Inc.Contra..png" alt="Inscripción" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Inscripción en el padrón de Contratistas del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
            <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/406" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            <a href="https://ruts.hidalgo.gob.mx/ver/392" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>
          </div>
        </div>


          <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/Act.Datos.png" alt="Modificación" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Modificación en el padrón de Contratistas del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
            <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/412" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            <a href="https://ruts.hidalgo.gob.mx/ver/1602" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>
          </div>
        </div>


        <div className='col-md-4 col-12 ofiprov-card'>
          <img src="/assets/imgs/oficina_virtual/Revalidación.png" alt="Revalidación" className='ofiprov-img' />
          <h2 className='ofiprov-subtitle'>Revalidación en el padrón de Contratistas del Estado de Hidalgo</h2>
          <div className='ofiprov-links'>
             <a href="https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/1599" target="_blank" rel="noopener noreferrer" 
            className='btn-oficina'>Ir al Servicio</a>
            <a href="https://ruts.hidalgo.gob.mx/ver/409" target="_blank" rel="noopener noreferrer" className='btn-oficina'>Requisitos</a>
            <span className='btn-oficina btn-oficina--red'>Video Tutorial</span>
          </div>
        </div>

       

        <div className='col-12 ofiprov-contact'>
          <div className='ofiprov-contact-box'>
            <p>Para cualquier consulta, ponemos a su disposición los siguientes medios de contacto en horario laboral, de 9:00 a.m. a 5:00 p.m.:</p>
            <p><strong>Correo electrónico:</strong> <a href="mailto:agenda.padron@hidalgo.gob.mx">agenda.padron@hidalgo.gob.mx</a></p>
            <p><strong>Teléfonos:</strong> 7717183497</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OficinaVirtualContratista;
